import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useDeleteIndustry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/industry/delete/${id}`);
      return res.data;
    },
    onSuccess: (_data, id) => {
      // Remove row immediately from cached list (fast UI update)
      if (id) {
        queryClient.setQueryData(["viewIndustry"], (old) => {
          const oldList =
            old?.data?.industry ||
            old?.data ||
            old?.industry ||
            old ||
            [];

          if (!Array.isArray(oldList)) return old;
          const nextList = oldList.filter((x) => (x?._id || x?.id) !== id);

          if (old && typeof old === "object" && !Array.isArray(old)) {
            if (Array.isArray(old.data)) return { ...old, data: nextList };
            if (old.data && typeof old.data === "object" && Array.isArray(old.data.industry)) {
              return { ...old, data: { ...old.data, industry: nextList } };
            }
            if (Array.isArray(old.industry)) return { ...old, industry: nextList };
            return { ...old, data: nextList };
          }

          return nextList;
        });
      }

      queryClient.invalidateQueries({ queryKey: ["viewIndustry"] });
    },
  });
};